/**
 * Boost Side Cart Fixes
 * 1. Free shipping progress bar in cart footer ($80 threshold)
 * 2. Item count correction: fractional yardage products (2 units = 1 yard)
 *    show as yard count in the cart header and nav badge
 *
 * Robust against Boost re-renders: observer + 400ms polling fallback.
 */

(function () {
  'use strict';

  const FREE_SHIPPING_CENTS = 8000;
  const BAR_ID = 'boost-free-shipping-bar';

  var cachedCart = null;
  var debounceTimer = null;

  // ── helpers ───────────────────────────────────────────────────────────────

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function calcAdjustedCount(cart) {
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.properties && item.properties['_is_fractional'] === 'true') {
        count += item.quantity / 2;
      } else {
        count += item.quantity;
      }
    });
    return Math.round(count);
  }

  // ── nav badge ─────────────────────────────────────────────────────────────

  function updateNavBadge(adjustedCount) {
    var badge = document.querySelector('.cart-link__count');
    if (badge) badge.textContent = adjustedCount;
  }

  // ── modal item count ──────────────────────────────────────────────────────

  function updateModalCount(adjustedCount, retryCount) {
    retryCount = retryCount || 0;
    var countEl = document.querySelector('.boost-sd__modal[aria-modal="true"] .boost-sd__cart-items-count');
    if (!countEl) {
      if (retryCount < 10) setTimeout(function () { updateModalCount(adjustedCount, retryCount + 1); }, 100);
      return;
    }
    var label = adjustedCount === 1 ? 'item' : 'items';
    countEl.textContent = 'Your cart (' + adjustedCount + ' ' + label + ')';
  }

  // ── free shipping bar ─────────────────────────────────────────────────────

  function renderBar(totalCents, retryCount) {
    retryCount = retryCount || 0;
    var footer = document.querySelector('.boost-sd__cart-footer');
    if (!footer) {
      if (retryCount < 10) setTimeout(function () { renderBar(totalCents, retryCount + 1); }, 100);
      return;
    }

    var bar = document.getElementById(BAR_ID);
    if (!bar) {
      bar = document.createElement('div');
      bar.id = BAR_ID;
      bar.style.cssText = 'padding:12px 16px 4px;';
      footer.insertBefore(bar, footer.firstChild);
    }

    if (totalCents >= FREE_SHIPPING_CENTS) {
      bar.innerHTML =
        '<div style="background:#f0fdf4;border:1px solid #4ade80;border-radius:6px;padding:10px 14px;font-size:0.83em;color:#15803d;font-weight:600;text-align:center;">' +
          'You\'ve unlocked free shipping!' +
        '</div>';
    } else {
      var remaining = FREE_SHIPPING_CENTS - totalCents;
      var pct = Math.min(100, Math.round(totalCents * 100 / FREE_SHIPPING_CENTS));
      bar.innerHTML =
        '<div style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:6px;padding:10px 14px;">' +
          '<p style="margin:0 0 8px;font-size:0.82em;color:#166534;">Add <strong>' + moneyFormat(remaining) + '</strong> more for <strong>free shipping</strong>!</p>' +
          '<div style="background:#dcfce7;border-radius:100px;height:6px;overflow:hidden;">' +
            '<div style="background:#16a34a;height:100%;border-radius:100px;width:' + pct + '%;transition:width 0.4s ease;min-width:4px;"></div>' +
          '</div>' +
        '</div>';
    }
  }

  // ── orchestration ─────────────────────────────────────────────────────────

  function applyCartUpdates(cart) {
    cachedCart = cart;
    var adjustedCount = calcAdjustedCount(cart);

    // Nav badge: always update (visible whether cart is open or not)
    updateNavBadge(adjustedCount);

    // Boost modal updates only when cart is open
    var boostCart = document.querySelector('.boost-sd__modal[aria-modal="true"]');
    if (boostCart && boostCart.style.display !== 'none') {
      updateModalCount(adjustedCount);
      renderBar(cart.total_price);
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(applyCartUpdates)
      .catch(function (e) { console.error('[Boost Cart Fixes] fetch error:', e); });
  }

  function updateCart() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchAndUpdate, 80);
  }

  // ── observer ──────────────────────────────────────────────────────────────

  var observer = new MutationObserver(function () {
    var boostCart = document.querySelector('.boost-sd__modal[aria-modal="true"]');
    if (boostCart && boostCart.style.display !== 'none') {
      updateCart();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-modal', 'style']
  });

  // ── polling fallback ──────────────────────────────────────────────────────
  // Nav badge: FSA app overwrites the count after page load, so re-correct it continuously.
  // Boost modal bar/count: re-apply if Boost re-renders and removes them.

  setInterval(function () {
    // Always: keep nav badge correct (FSA app sets it back to raw item_count after init)
    if (cachedCart) {
      var adjustedCount = calcAdjustedCount(cachedCart);
      var badge = document.querySelector('.cart-link__count');
      if (badge && badge.textContent != adjustedCount) {
        badge.textContent = adjustedCount;
      }
    }

    var boostCart = document.querySelector('.boost-sd__modal[aria-modal="true"]');
    if (!boostCart || boostCart.style.display === 'none') return;

    var barMissing = !document.getElementById(BAR_ID);
    var countEl = document.querySelector('.boost-sd__cart-items-count');
    // Detect if Boost overwrote our corrected count back to the raw unit count
    var countReset = cachedCart && countEl &&
      calcAdjustedCount(cachedCart) !== cachedCart.item_count &&
      countEl.textContent.indexOf(cachedCart.item_count + ' ') !== -1;

    if (barMissing || countReset) {
      if (cachedCart) {
        applyCartUpdates(cachedCart);
      } else {
        fetchAndUpdate();
      }
    }
  }, 400);

  // ── init ──────────────────────────────────────────────────────────────────

  // Correct nav badge on page load (Liquid renders raw item_count, wrong for fractional)
  fetchAndUpdate();

  document.addEventListener('cart:updated', updateCart);
  document.addEventListener('cart.requestComplete', updateCart);

  console.log('[Boost Cart Fixes] v2 Initialized');
})();
